import axios from "../axios";

export async function fetchDeviationTypes(controller) {
  return axios({
    method: "get",
    url: "/quality/deviations/types",
    params: controller,
  });
}
